import { UserState } from './UserTypes';

export const UserActionTypes = {
  LOAD_USER_DETAILS: 'loadUserDetails',
  LOADED_USER_DETAILS: 'loadedUserDetails',
  LOAD_USER_DETAILS_ERROR: 'loadUserDetailsError',
};

export const DEFAULT_STATE: UserState = {
  user_details: {},
};
